import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { PublicatiiCasatoriiService } from '../publicatii-casatorii.service';
import { NotificationService } from 'src/app/services/notification.service';
import { IAddPublicatieCasatoriePayload, IPublicatieCasatorieForm } from '../publicatii-casatorii.interface';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-add-publicatie',
    templateUrl: './add-publicatie.component.html',
    styleUrls: ['./add-publicatie.component.scss']
})
export class AddPublicatieComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        spouse_1: new FormControl('', [Validators.required]),
        spouse_2: new FormControl('', [Validators.required]),
        marriage_date: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddPublicatieComponent>,
        private publicatiiCasatoriiService: PublicatiiCasatoriiService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    formatDate(date: Date): string {
        const day: number = date.getDate();
        const month: number = date.getMonth() + 1; // Months are zero-based, so add 1
        const year: number = date.getFullYear();

        const dayString: string = day < 10 ? '0' + day : day.toString();
        const monthString: string = month < 10 ? '0' + month : month.toString();

        return `${year}-${monthString}-${dayString}`;
    }

    submitForm() {
        this.isLoading = true;

        const { spouse_1, spouse_2, marriage_date } = this.form.value as IPublicatieCasatorieForm;
        const payload: IAddPublicatieCasatoriePayload = {
            spouse_1,
            spouse_2,
            marriage_date: this.formatDate(marriage_date),
        };

        this.publicatiiCasatoriiService
            .addPublicatie(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
